import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPerspective = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Perspective",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.125 6.34386H12.4688V2.62511C12.4687 2.46492 12.4335 2.30671 12.3655 2.16164C12.2976 2.01658 12.1986 1.8882 12.0756 1.7856C11.9526 1.68299 11.8086 1.60865 11.6537 1.56784C11.4988 1.52702 11.3368 1.52073 11.1792 1.5494L2.42922 3.14026C2.1773 3.1861 1.94944 3.31886 1.78535 3.51543C1.62126 3.712 1.53134 3.95991 1.53125 4.21597V6.34386H0.875C0.700952 6.34386 0.534032 6.413 0.410961 6.53607C0.28789 6.65914 0.21875 6.82606 0.21875 7.00011C0.21875 7.17415 0.28789 7.34107 0.410961 7.46415C0.534032 7.58722 0.700952 7.65636 0.875 7.65636H1.53125V9.78425C1.53134 10.0403 1.62126 10.2882 1.78535 10.4848C1.94944 10.6813 2.1773 10.8141 2.42922 10.86L11.1792 12.4508C11.3368 12.4795 11.4988 12.4732 11.6537 12.4324C11.8086 12.3916 11.9526 12.3172 12.0756 12.2146C12.1986 12.112 12.2976 11.9836 12.3655 11.8386C12.4335 11.6935 12.4687 11.5353 12.4688 11.3751V7.65636H13.125C13.299 7.65636 13.466 7.58722 13.589 7.46415C13.7121 7.34107 13.7812 7.17415 13.7812 7.00011C13.7812 6.82606 13.7121 6.65914 13.589 6.53607C13.466 6.413 13.299 6.34386 13.125 6.34386ZM2.84375 4.39862L11.1562 2.88761V6.34386H2.84375V4.39862ZM11.1562 11.1126L2.84375 9.60159V7.65636H11.1562V11.1126Z",
			fill: "currentColor"
		})
	})
});
export default SvgPerspective;
